module.exports = __webpack_public_path__ + "img/help-icon5.6567bae7.png";